export const TEACHER_DATA_DEFINITIONS = {
  Name: "Teacher’s name and email with a link to their faculty page.",
  "School name": "Teacher’s school name.",
  "Subject(s)": "Subjects associated with non-archived classrooms.",
  "Activity this school year":
    "Yes or No on if a Teacher has had students who have taken action on Newsela at least once this school year.",
  "Number of active days": "The sum (total) number of active days by students.",
  "Articles viewed":
    "The sum of unique articles viewed by teachers in both Spanish and English. Represent a single article viewed, no matter how many times a user changes the level of a text or revisits a text.",
  "Assignments created": "All assignments created in classrooms and groups.",
  "Content prints":
    "Total number of times teachers have printed or downloaded print-versions of different levels of articles.",
  "Annotations created":
    "Total number of annotations (e.g. highlighting, commenting) created by teachers on Newsela.",
  "Reporting views": "The number of times the user has viewed reporting.",
  "Text sets created":
    "The sum of instances in which a teacher adds an article header to a Text Set.",
};

export const SCHOOL_DATA_DEFINITIONS = {
  "School name": "Name of School.",
  Subscriptions: "Newsela Products being used at school.",
  "Activity this school year":
    "Yes or No on if a school has had unique teachers who have accessed Newsela at least once this school year.",
  "Active teachers":
    "Total number of unique teachers who’ve accessed Newsela at least once based on selected filters.",
  "Articles viewed": "Total number of distinct viewed articles.",
  "Total assignments":
    "The total number of assignments created by teachers and assigned to students in the Newsela application. This does not include assignments shared via an LMS.",
  "Total prints":
    "Total number of times teachers have printed or downloaded print-versions of different levels of articles.",
  "Active students":
    "Total number of students who have taken any action on Newsela in the given time frame.",
  "Students who viewed content":
    "Total number of students who have viewed at least one article in the given time frame",
  "Students who submitted activities":
    "Total number of students who participated in at least one Newsela activity, either independently or as part of assignment based on selected filters.",
  "Total article views":
    "The sum of unique article views by teachers in both Spanish and English. Article headers views represent a single article view, no matter how many times a user changes the level of a text or revisits a text.",
  "Total article views with submitted activities":
    "The total of unique article views with students who participated either independently or as part of assignment.",
  "Quizzes completed":
    "Total number of quizzes completed by your students on Newsela.",
  "Quizzes completed per active student":
    "Average number of unique quizzes completed by active students.",
};
